export default __webpack_public_path__ + "static/media/filter.6bdcd7fa.png";